import { Link } from "react-router-dom";
import logo from '../../assets/logoblack.png'
import amigos from "../../assets/contenido/amigos.png";

export default function RegulationsPlanFriends() {
  return (
    <div className="contenedor_joinus">
       <nav className="navbar navbar-light mb-5" id="encabezado">
                <Link to="/" className="container-fluid">
                    <img
                    src={logo}
                    width="290"
                    height="550"
                    className="img-fluid d-block mx-auto"
                    alt='logoMingga'
                    />
                </Link>
            </nav>

            <div className="container-fluid">
            <div className="privacy" align="left" id="padding">
              <h3 align="center">ACUERDO 02 DE 2025<br /></h3>
                <h5 align="center"> <b>REGLAMENTO DEL PLAN AMIGOS LEO</b></h5>
                <br />
                
                <h6 align="center"> <b>CAPITULO I</b></h6>
                <h6 align="center"> <b>DEFINICION, OBJETIVOS Y ALCANCES</b></h6>
                <p> 
                <b>Artículo 1. – Definición.</b> El <b>Plan Amigos LEO</b> es la estrategia para el crecimiento del Club Mundial de Lectura en el país y todo el mundo, a través del apoyo de los socios que invitan a otras personas a ingresar como socios, por lo cual reciben los ingresos y beneficios establecidos en este Reglamento.
                </p>
                <p> 
                <b>Artículo 2. – Objetivos.</b> Con el <b>Plan Amigos LEO</b>, se busca lograr los siguientes objetivos: <br />
                1. El crecimiento sostenido del número de socios de LEO Club Mundial de Lectura, para contar con los ingresos operacionales necesarios para el funcionamiento y la prestación de servicios a la comunidad en el país y todo el mundo. <br />
                2. Organizar una comunidad mundial de instituciones y personas promotoras de la lectura, la escritura y el multilingüismo, como hábitos que mejoren el nivel educativo y cultural de las personas y sus competencias comunicativas. <br />
                3. Aprovechar la internet y su cobertura mundial para facilitar el crecimiento de LEO y el trabajo de invitación que realizan los socios.
                4. Ofrecer a los socios de LEO la oportunidad para que puedan construir un ingreso creciente y permanente que garantice su independencia financiera, con su participación por la invitación a vincularse a LEO.  <br />


                </p>
                <p>
                <b>Artículo 3. - Principios Básicos del Plan Amigos.</b>
                1. Participación Libre y Voluntaria. El ingreso de los socios LEO al Plan Amigos es libre y voluntario, al igual que la permanencia y retiro, que puede darse en cualquier momento, sin requisitos ni condiciones.<br />
                2. Un socio puede decidir no participar del Plan Amigos, y continuar disfrutando los programas y servicios de LEO.<br />
                3. Cada socio puede invitar a máximo 20 nuevos socios. Para el efecto, debe proporcionarles su usuario o link personal de identificación para que lo ingresen en el formulario de registro.<br />
                4. Los socios de LEO pueden residir en cualquier país del mundo.
                5. La vinculación se realiza por internet a través del portal web institucional www.clubleo.net.
                6. Vinculación única. Cada socio podrá participar una sola vez en el Plan Amigos. Las cuentas múltiples de una persona serán anuladas.          
                  <br />
                




                </p>

                <br />
                <h3 align="center">CAPITULO II<br /></h3>
                <h5 align="center"> <b>Beneficios</b></h5> 
                <p>
                <b>Artículo 4. </b> – El socio que voluntariamente participe en el Plan Amigos, tendrá como meta invitar a máximo 20 personas a ingresar como socios de LEO, y recibirá los siguientes beneficios: <br />

                1.	En el primer paso de invitación a los 20 socios directos, un ingreso del 10% del valor de la suscripción a ClubLeo de cada uno de ellos
                2. En el segundo paso, cuando sus 20 socios directos completen cada uno sus 20 invitados, el socio recibirá un ingreso del 20% del valor de la suscripción a ClubLeo
                3. Finalmente, en el tercer paso, cuando los nuevos socios inviten a sus 20 amigos, recibirá un ingreso del 30% del valor de la suscripción a ClubLeo.
                
                Estos ingresos se acumularán mensualmente y se girarán dentro de la semana siguiente a la cuenta financiera que reporte a LEO. Para recibir y mantener el ingreso durante suscripciones sucesivas de los socios invitados, se deberá mantener la condición de socio de LEO.
            
                Si no se renueva la suscripción como socio LEO, se perderá el beneficio en forma definitiva
                </p>
                <br />
                <p>
                <b>Artículo 5. </b>– Los diferentes beneficios que ofrece LEO sus socios que participen del Plan Amigos serán inmediatos una vez se cumplan las metas de vinculación de nuevos socios.  para lo cual se deberá mantener la condición de socio LEO. Si no se renueva la vinculación como socio LEO, se perderán los beneficios del Plan Amigos.                </p>
                <p>
                <b>Artículo 6. Propiedad </b>– Los socios de LEO que participen del Plan Amigos, tendrán de por vida la propiedad sobre los beneficios económicos por la invitación a otras personas a ingresar como socios de LEO, conforme a lo establecido en el Artículo 4 de este Reglamento. Para conservar este derecho, deberán mantener vigente la vinculación como socios de LEO.                </p>
                <p>
                <b>Artículo 7. - Aprobación.</b> Reglamento aprobado en la sesión conjunta de la Editorial Educativa Biblicol SAS y la Asociación LEO Club Mundial de Lectura, realizada el 4 de agosto de 2025.                </p>
                <br />
                <br />
                <h6 align="center"><b>DIANA MARCELA ROMERO ROJAS</b><br /></h6>
                <p align="center"> Directora del Programa</p> 
            

            </div>
            </div>
              
      <br />         
    </div>
  );
}
